var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-title"},[_c('el-divider',{attrs:{"direction":"vertical"}}),_c('span',[_vm._v(_vm._s(_vm.tittle))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }